import { useAuth } from "../../auth/useAuth";

export default function Topbar() {
  const { member, logout } = useAuth();

  return (
    <header className="bo-topbar">
      <div className="bo-topbar__user">
        Connecté en tant que{" "}
        <span className="bo-topbar__user-name">{member?.userName ?? member?.userId ?? "—"}</span>
        {member && <span className="bo-topbar__role">{member.role}</span>}
      </div>
      <button onClick={logout} className="bo-topbar__logout" type="button">
        Déconnexion
      </button>
    </header>
  );
}
